import {trigger, state, animate, transition, style, query, animateChild, stagger} from '@angular/animations';

export const rowRemove =
  trigger('rowRemove', [
    transition(':leave', [
      style({background: 'red', opacity: 1}),
      animate('0.35s ease', style({opacity: 0, transform: 'translateX(-550px)'}))
    ])
  ]);


export const blub =
  trigger('blub', [
    transition('* => void', [
      query('@rowsAnimation', [animateChild()], {optional: true})
    ]),
  ]);

export const inOutAnimations = [
  trigger('inOut', [
    state('in', style({height: 'auto'})),
    transition('void => *', [
      style({height: 0}),
      animate(100)
    ]),
    transition('* => void', [
      animate(100, style({height: 0}))
    ])
  ]),
];
